export default __webpack_public_path__ + "static/media/sikh.ba376fe5bb7bde99a4eb6b3af142ce8d.png";